module.exports = __webpack_public_path__ + "img/7.d4245861.jpg";